export default "__VITE_ASSET__DbAOU$8C__"